import React from "react";
import { FlatList as NFlatList } from "native-base";
import type { IFlatListProps } from "native-base/lib/typescript/components/basic/FlatList/types";

export const FlatList = <ItemT extends any>(
  props: IFlatListProps<ItemT>
): JSX.Element => {
  return <NFlatList {...props} />;
};

export default FlatList;
